import { useState, useEffect } from 'react';
import roleCheck from '../components/Layout/roleCheck';
import { useSelector } from 'react-redux';
import RootState from '../redux/states/root.state';
import permissionCheck from '../components/Layout/permissionCheck';

const useRoleCheck = (rolesToCheck: string[], ignoreImpersonation?:boolean): any => {
    const {data:user} = useSelector((state: RootState) => state.user);
    const [canAccess, setCanAccess] = useState(false);
    const [checking, setChecking] = useState(true);


    useEffect(() => {
        if (!user) return;
        var impersonating = sessionStorage.getItem("impersonate");
        let canImpersonate = !ignoreImpersonation  // not ignoring impersonation
                            && impersonating!==null  // there is an impersonation in storage
                            && !['admin','developer','corporate'].includes(impersonating)  // the impersonation is NOT of these roles
                            && permissionCheck(user,['can_impersonate_user']);  // the user IS one of these roles
        
        if (impersonating && canImpersonate) {
            setCanAccess(rolesToCheck.includes(impersonating)|| false);

        } else {
            setCanAccess(roleCheck(user,rolesToCheck))
        }
        setChecking(false);
    }, [ignoreImpersonation, user, rolesToCheck]);

    return {canAccess, checking};
};

export default useRoleCheck;
